// Remove EmailJS related imports as we won't be sending emails
// import { useRef } from "react";
// import emailjs from "@emailjs/browser";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// Import icons for phone and WhatsApp if you want them to look nice
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa";

const Contact = () => {
  // No need for form useRef or sendEmail function

  // Restaurant Contact Details
  const phoneNumber = "+918707091524"; // Your contact number
  const restaurantName = "Momo.com Fast Food & Restaurant"; // Your restaurant name
  const whatsappNumber = "918707091524"; // WhatsApp number (without +)

  // Pre-filled WhatsApp message
  const whatsappMessage = encodeURIComponent(`Hello ${restaurantName}, I'd like to get in touch regarding...`);

  return (
    
    <section
      id="contact"
      className="flex flex-col items-center justify-center py-24 px-[12vw] md:px-[7vw] lg:px-[20vw] bg-[#000000] min-h-screen" // Added min-h-screen to ensure it takes up enough space
    >
      {/* Remove ToastContainer as no more toasts from EmailJS */}
      {/* <ToastContainer /> */}

      <div className="text-center mb-16">
        <h2 className="text-4xl font-bold text-white">CONTACT US</h2> {/* Changed heading to plural */}
        <div className="w-32 h-1 bg-purple-500 mx-auto mt-4"></div>
        <p className="text-gray-400 mt-4 text-lg font-semibold">
          Reach out to us for orders, inquiries, or feedback!
        </p>
      </div>

      <div className="mt-8 w-full max-w-md bg-[#0d081f] p-6 rounded-lg shadow-lg border border-gray-700 text-center">
        <h3 className="text-xl font-semibold text-white mb-6">
          Connect with {restaurantName}
        </h3>

        <div className="flex flex-col space-y-6">
          {/* Phone Number Call */}
          <a
            href={`tel:${phoneNumber}`}
            className="flex items-center justify-center bg-gradient-to-r from-purple-600 to-pink-500 py-3 text-white font-semibold rounded-md hover:opacity-90 transition-all duration-300 transform hover:scale-105"
          >
            <FaPhoneAlt className="mr-3" size={20} /> Call Us: {phoneNumber}
          </a>

          {/* WhatsApp Message */}
          <a
            href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center bg-green-600 py-3 text-white font-semibold rounded-md hover:bg-green-700 transition-all duration-300 transform hover:scale-105"
          >
            <FaWhatsapp className="mr-3" size={24} /> Message Us on WhatsApp
          </a>

          {/* Optional: Add a simple text about visiting if applicable */}
          <p className="text-gray-400 mt-6 text-sm">
            Visit us at our location or connect with us online!
          </p>
        </div>
      </div>
    </section>
  );
};

export default Contact;